import ISiteDiaryModel from "interfaces/SiteDiary/ISiteDiaryModel";
import ISiteDiaryViewModel from "interfaces/SiteDiary/ISiteDiaryViewModel";

function mapSiteDiaryToViewModel(
  siteDiary: ISiteDiaryModel
): ISiteDiaryViewModel {
  const siteDiaryViewModel : ISiteDiaryViewModel = {
    weatherCondition: siteDiary?.weatherCondition,
    reportTimes: siteDiary.reportTimes.map(reportTime => new Date(reportTime)),
    submittedReportTimes: siteDiary.submittedReportTimes.map(reportTime => new Date(reportTime)),
    gatesOpened: siteDiary.gatesOpened ? new Date(siteDiary.gatesOpened!) : undefined,
    gatesClosed: siteDiary.gatesClosed ? new Date(siteDiary.gatesClosed!) : undefined,
    isEmpty: false

  };

  return siteDiaryViewModel;
}

export { mapSiteDiaryToViewModel };
